import AutoconfirmationForm from '@/components/newsletter/AutoconfirmationForm'

export function init () {
  const root = document.querySelector('.newsletter-confirmation')
  if (root) {
    const form = new AutoconfirmationForm(root)
    if (form.exists()) {
      form.hide()
      form.submit()
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/newsletter/autoconfirmation.js